export class CleaningGroup {
  GroupId : number;
  Subscriber : string;
  HotelId : number;
  GroupName : string;
  SData: string;
}